const questionsTheme = {
    primaryTeal: '#008b8b',
    primaryOrange: '#d35400',
    correctGreen: '#2e7d32',
    incorrectRed: '#d32f2f',
    lightTeal: '#e0f7fa',
    lightRed: '#fdeceb',
    unmarkedGray: '#e0e0e0',
    textDark: '#333'
};

export default questionsTheme;
